<template>
    <div id="contenedor-configuracion-plantillas-etiquetas-listado-desktop"
        >
      <v-list
        two-line
        dense
        flat
        nav >
        <v-list-item>
          <v-text-field
            v-model="etiquetaBusca"
            dense
            filled
            rounded
            hide-details
            full-width
            placeholder="Buscar..."
            append-icon="mdi-magnify"
          >
          </v-text-field>
        </v-list-item>
        <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
        <v-list-item
          v-for="(etiqueta) in etiquetas"
          :key="etiqueta.etiqueta"
          >
          <v-list-item-content>
            <v-list-item-title class="base4 font-weight-bold primary--text h2"
              v-text="etiqueta.etiqueta">
            </v-list-item-title>
            <v-list-item-subtitle v-html="etiqueta.descripcion+'<br>'+etiqueta.salida">
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action >
          </v-list-item-action>
        </v-list-item>
      </v-list>

    </div>
</template>

<script>
import etiquetasPropiedades from '@/components/administracion/configuracion/plantillas/etiquetas/etiquetasPropiedades';

export default {
  name: 'ConfiguracionPlantillasEtiquetasListado',

  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrarEtiquetas: true,
      etiquetaBusca: '',
      etiquetas: [],
    };
  },

  mounted() {
    this.etiquetas = this.etiquetasLlaves;
    this.getEtiquetas();
  },
  computed: {
    etiquetasLlaves() {
      return etiquetasPropiedades;
    },
  },
  methods: {
    activarMostrarEtiquetas() {
      this.mostrarEtiquetas = !this.mostrarEtiquetas;
    },

    getEtiquetas() {
      const buscaTexto = this.etiquetaBusca;
      this.etiquetas = this.etiquetasLlaves
        .filter((e) => (e.modulo.includes(this.modulo)
        && e.visible === true
        && e.etiqueta.toUpperCase().includes(buscaTexto.toUpperCase())))
        .sort((a, b) => {
          if (a.etiqueta < b.etiqueta) return -1;
          if (a.etiqueta > b.etiqueta) return 1;
          return 0;
        });
    },

  },
  watch: {
    etiquetaBusca: {
      handler() {
        this.getEtiquetas();
      },
    },
  },
};
</script>

<style>

</style>
